import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SingleArrow",
  "use": "SingleArrow-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"SingleArrow\"><path fill=\"none\" stroke=\"#231f20\" stroke-miterlimit=\"10\" stroke-width=\"30\" d=\"M334.83 130.61L200 265.44 65.17 130.61\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol